function parseJSON(response) {
  return response.json();
}

// eslint-disable-next-line
export default function request(url, options) {
  return fetch(url, options).then(parseJSON);
}
